import { render, staticRenderFns } from "./sideNav.html?vue&type=template&id=332b8225&scoped=true&external"
import script from "./sideNav.js?vue&type=script&lang=js&external"
export * from "./sideNav.js?vue&type=script&lang=js&external"
import style0 from "./sideNav.scss?vue&type=style&index=0&id=332b8225&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b8225",
  null
  
)

export default component.exports